import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const TOKEN_KEY = "peart_auth_token";
const TOKEN_EXPIRY_KEY = "peart_auth_token_expiry";

export default function useAuthGuard() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem(TOKEN_KEY);
      const expiry = localStorage.getItem(TOKEN_EXPIRY_KEY);
      const now = Date.now();

      if (!token || !expiry || now > parseInt(expiry, 10)) {
        // Token fehlt oder abgelaufen
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(TOKEN_EXPIRY_KEY);
        navigate("/login", { replace: true });
      }
    };

    checkAuth();
  }, [navigate]);
} 